import { Rapport } from "../.generated/rapportage/rapportagetypes";


export const getRapportage = async (
  settings: any,
  bearerToken: string,
  vestigingId: string,
  adviesdossierId: string,
  rapportId: string,
  signal: AbortSignal

): Promise<Rapport | null> => {
  const url = `${settings.rapportageOrigin}/adviesdossier/${adviesdossierId}/rapportage/${rapportId}`;
  const rsp = await fetch(url, {
    method: "GET",
    headers: {
      authorization: `Bearer ${bearerToken}`,
      "Ocp-Apim-Subscription-Key": settings.OcpApimSubscriptionKey,
      "Content-Type": "application/json;charset=UTF-8",
      vestigingId
    },
    signal
  }).catch((e: Error) => {
    return null;
  });

  if (rsp === null) return rsp;

  if (!rsp.ok) {
    return null;
  }

  const contentType = rsp.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    return null;
  }

  const json = await rsp.json();

  return json;
};
